import * as React from "react"
import { Box } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"

import { NotAllowedBlock } from "@components"


export default function firstSeenColumn() {
	return [{
		name: 'lastSeen', label: 'Last Seen Ever \n on website',
		options: {
			display: 'excluded',
			customBodyRowRender: value => formatDate(value, { isString: true })
		}
	},{
		name: 'lastSeen', 
		label: 'Last Seen Ever \n on website',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'pre-line', minWidth: 30 }
			}),
			setCellProps: () => ({ sx: { textAlign: 'center' } }),
			customBodyRowRender: value => <Box sx={{ textAlign: 'center' }}>
				{ value ? formatDate(value, { isString: true }) : <NotAllowedBlock /> }
			</Box>
		}
	}]
}